import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import initActionsCreator from './redux/foldersInit';

export const getFoldersWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  initActionsCreator,
});
